import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "form-slug" }

import { computed, ref, watchEffect } from "vue";
import { useI18n } from "vue-i18n";
import debounce from "lodash-es/debounce";

import { maskSlug } from "@/common/utils/mask";

import type { SlugType, SlugPayloadType } from "@/common/types/slug";

import { baseInput, baseSelect } from "@/common/components";


export default /*@__PURE__*/_defineComponent({
  __name: 'form-slug',
  props: {
    data: {},
    type: {},
    isPatch: { type: Boolean },
    disableIsMain: { type: Boolean }
  },
  emits: ["update:data", "update:isMain", "salve:data"],
  setup(__props: any, { emit: __emit }) {

const { t } = useI18n();

const emit = __emit;

const props = __props;

const DEFAULT_DATA = {
  is_main: 0,
  language: null,
  slug: null,
  type: props.type,
};

const payload = ref<SlugPayloadType>({ ...DEFAULT_DATA });

const languagesOptions = computed(() => [
  {
    option: "Português (BR)",
    value: "pt-br",
  },
  {
    option: "English (US)",
    value: "en-us",
  },
]);

const optionsYesNot = computed(() => [
  {
    option: t("common.labels.yes"),
    value: 1,
  },
  {
    option: t("common.labels.not"),
    value: 0,
  },
]);

function update(key: keyof typeof payload.value) {
  if (props.isPatch) {
    emit("update:data", { [key]: payload.value[key] });
    return;
  }

  emit("update:data", payload.value);
}

function updateIsMain() {
  emit("update:isMain", { is_main: payload.value.is_main });
}

function resumeData() {
  if (!props.data) return;

  const { slug, is_main, language } = props.data;

  payload.value = {
    ...payload.value,
    slug,
    is_main,
    language,
  };
}

const debouceUpdate = debounce(update, 300);

watchEffect(() => {
  resumeData();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_unref(baseInput), {
      modelValue: payload.value.slug,
      "onUpdate:modelValue": [
        _cache[0] || (_cache[0] = ($event: any) => ((payload.value.slug) = $event)),
        _cache[1] || (_cache[1] = ($event: any) => (_unref(debouceUpdate)('slug')))
      ],
      value: payload.value.slug,
      placeholder: _unref(t)('slug.placeholders.slug'),
      mask: _unref(maskSlug),
      required: ""
    }, {
      label: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(t)("slug.labels.slug")) + " * ", 1)
      ]),
      _: 1
    }, 8, ["modelValue", "value", "placeholder", "mask"]),
    _createVNode(_unref(baseSelect), {
      modelValue: payload.value.is_main,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((payload.value.is_main) = $event)),
      value: payload.value.is_main,
      options: optionsYesNot.value,
      "is-empty": false,
      disabled: __props.disableIsMain,
      onChange: _cache[3] || (_cache[3] = ($event: any) => (updateIsMain()))
    }, {
      label: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(t)("slug.labels.is_main")), 1)
      ]),
      _: 1
    }, 8, ["modelValue", "value", "options", "disabled"]),
    _createVNode(_unref(baseSelect), {
      modelValue: payload.value.language,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((payload.value.language) = $event)),
      value: payload.value.language,
      options: languagesOptions.value,
      "is-empty": true,
      onChange: _cache[5] || (_cache[5] = ($event: any) => (_unref(debouceUpdate)('language')))
    }, {
      label: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(t)("slug.labels.language")), 1)
      ]),
      _: 1
    }, 8, ["modelValue", "value", "options"])
  ]))
}
}

})